import { styled, StyleSystemProps, Flex, Box, css } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Dimensions } from './types';
import { CheckFilled } from '@withjoy/joykit/icons';

export const StyledCheckFilled = styled(CheckFilled)``;
const checkFilledStyles: StyleSystemProps = {
  backgroundColor: 'white',
  borderRadius: '50%',
  outline: '2px solid white',
  position: 'absolute',
  right: 0
};

export const StyledProgressRing = styled.circle<{ dashoffset: number; progress?: number }>`
  stroke-dashoffset: ${props => props.dashoffset};
  transition: 0.35s stroke-dashoffset;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  fill: transparent;
  ${props =>
    props.progress &&
    css`
      stroke-dashoffset: ${(props: { dashoffset: number; progress?: number }) => props.progress};
    `};
`;

const progressRingSize = ({ dimensions }: { dimensions: Dimensions }) => `
  width: ${pxToRem(dimensions.width)};
  height: ${pxToRem(dimensions.height)};
`;

export const StyledProgressRingWrapper = styled(Box)<{ dimensions: Dimensions }>`
  ${props => progressRingSize(props)}
`;
const progressRingWrapperStyles: StyleSystemProps = {
  position: 'relative',
  display: 'flex'
};

export const StyledIconWrapper = styled(Flex)``;
const iconWrapperStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',
  top: 0
};

export const StyledSvg = styled.svg<{ dimensions: Dimensions }>`
  ${props => progressRingSize(props)}
`;

export const styles = {
  checkFilled: checkFilledStyles,
  iconWrapper: iconWrapperStyles,
  progressRingWrapper: progressRingWrapperStyles
};
